import { BaseModel } from '../base.model';

export class DropDownItemDto extends BaseModel {
  public id: string;
  public text: string;
  public seq?: number;

  constructor(o: unknown = null) {
    super(o);
  }
}
